import { FastCrawlLoader } from "#webapp/src/components/fast-crawl-loader";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { ChromeAppWrapperView } from "#webapp/src/util/chrome-extension.util";
import classNames from "classnames";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { IProps } from "./ChromeNavTypes";
import {
  ChromeNavCalendarProfile,
  ChromeNavCreateEvent,
  ChromeNavEvent,
  ChromeNavHome,
  ChromeNavTeamDashboard,
} from "./nav-content";

export const ChromeNav = ({ authed, defaultView, environment, org, view }: IProps) => {
  const onboardingFinished = useSelector(
    (state: IReduxState) => state.onboarding.onboardingFinished,
  );
  const fastCrawlFinished = useSelector((state: IReduxState) => state.onboarding.fastCrawlFinished);
  const mode = useSelector((state: IReduxState) => state.webExtension.mode);

  const [hovered, setHovered] = useState(false);

  const onHover = (newHovered: boolean) => {
    setHovered(newHovered);
  };

  const hasBottomBorder = () => {
    switch (view) {
      case ChromeAppWrapperView.GoogleContactSharingDisabled:
      case ChromeAppWrapperView.GoogleApiAccessDisabled:
      case ChromeAppWrapperView.ShouldCrawl:
      case ChromeAppWrapperView.NoCrawl:
      case ChromeAppWrapperView.NoAuth:
      case ChromeAppWrapperView.Onboarding:
      case ChromeAppWrapperView.TeamHealth:
      case ChromeAppWrapperView.Day:
      case ChromeAppWrapperView.CalendarProfile:
        return true;
      default:
        return false;
    }
  };

  const getContent = () => {
    const showMenu =
      authed &&
      onboardingFinished &&
      view !== ChromeAppWrapperView.PersonalCalendar &&
      view !== ChromeAppWrapperView.CalendarMismatch;

    const showTabs =
      authed &&
      onboardingFinished &&
      view !== ChromeAppWrapperView.PersonalCalendar &&
      view !== ChromeAppWrapperView.CalendarMismatch;

    if (!showTabs && view === ChromeAppWrapperView.TeamHealth) {
      return <ChromeNavTeamDashboard defaultView={defaultView} />;
    }

    switch (view) {
      case ChromeAppWrapperView.CalendarProfile:
        return <ChromeNavCalendarProfile org={org} environment={environment} />;
      case ChromeAppWrapperView.CreateEvent:
        return <ChromeNavCreateEvent />;
      case ChromeAppWrapperView.Event:
        return <ChromeNavEvent orgId={org?.id || null} defaultView={defaultView} />;
      case ChromeAppWrapperView.EventScheduler:
        return null;
      case ChromeAppWrapperView.CalendarMismatch:
      case ChromeAppWrapperView.TeamHealth:
      case ChromeAppWrapperView.Onboarding:
      case ChromeAppWrapperView.NoAuth:
      case ChromeAppWrapperView.NoOrg:
      case ChromeAppWrapperView.PersonalCalendar:
      case ChromeAppWrapperView.GoogleContactSharingDisabled:
      case ChromeAppWrapperView.GoogleApiAccessDisabled:
      case ChromeAppWrapperView.NoCrawl:
      case ChromeAppWrapperView.ShouldCrawl:
      default:
        return (
          <ChromeNavHome
            showMenu={showMenu}
            showTabs={showTabs}
            showCollapse={hovered && mode === "extension"}
            environment={environment}
            org={org}
            showLogo
          />
        );
    }
  };

  const maybeRenderFastCrawlLoader = () => {
    if (
      !authed ||
      fastCrawlFinished ||
      !onboardingFinished ||
      view === ChromeAppWrapperView.CalendarMismatch ||
      view === ChromeAppWrapperView.GoogleContactSharingDisabled ||
      view === ChromeAppWrapperView.GoogleApiAccessDisabled ||
      view === ChromeAppWrapperView.NoCrawl ||
      view === ChromeAppWrapperView.ShouldCrawl
    ) {
      return null;
    }

    return <FastCrawlLoader environment={environment} />;
  };

  return (
    <div
      className={classNames("cw-relative cw-bg-default cw-w-full cw-flex-shrink-0", {
        "cw-border-b cw-border-default cw-border-solid": hasBottomBorder(),
      })}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      {getContent()}
      {maybeRenderFastCrawlLoader()}
    </div>
  );
};
